
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/catering/[slug]",
      function () {
        return require("private-next-pages/catering/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/catering/[slug]"])
      });
    }
  